import ArticleListSection from '@src/components/ArticleListSection'
import { useRecommendations } from '@models/Personalize'
import { Article, useAllArticles } from '@models/Article'
import { useElementVisibility } from '@models/ElementVisibility'

export type RelatedArticlesProps = {
  article: Article
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ article }) => {
  const [ref] = useElementVisibility('article-related-container')
  const numberOfRelatedArticles = 6
  const recommendatinosArticles = useRelatedArticles(
    article,
    numberOfRelatedArticles,
  )

  return (
    <div ref={ref}>
      <ArticleListSection
        headlineProps={{
          subLine: '関連記事',
          head: 'RELATED ARTICLES',
          design: 'dark',
        }}
        listProps={{
          articles: recommendatinosArticles,
          displaysCategory: true,
          gtmClickType: 'related',
        }}
      />
    </div>
  )
}

const useRelatedArticles = (article: Article, numberOfArticles: number) => {
  // 存在しない記事IDを返される場合があるので、少し多めに設定
  const recommendations = useRecommendations(article, numberOfArticles + 3)
  const recommendArticleIdMap: { [blogId: string]: true } = {}
  recommendations.articles.forEach(
    article => (recommendArticleIdMap[article.blogId] = true),
  )

  const allArticles = useAllArticles()
  const sameCategoryArticles = allArticles
    .filter(
      allArticle =>
        allArticle.data.category === article.data.category &&
        allArticle.blogId !== article.blogId &&
        !recommendArticleIdMap[allArticle.blogId], // レコメンドとの重複を除く
    )
    .slice(0, numberOfArticles)

  const relatedArticles = [
    ...recommendations.articles,
    ...sameCategoryArticles,
  ].slice(0, numberOfArticles)

  return relatedArticles
}

export default RelatedArticles
